// extracted by mini-css-extract-plugin
module.exports = {"blockClick":"CustomFields_blockClick_Edk0n"};